// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-2b65886a] .dropdown-menu {\n  max-height: 110px !important;\n}\n[data-v-2b65886a] .table-responsive {\n  min-height: 120px;\n}\n.overlay-dcc[data-v-2b65886a] {\n  width: 96%;\n  height: 94%;\n  position: absolute;\n  background-color: #ddd;\n  z-index: 11;\n  opacity: 0.3;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
